var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAverecuraRgbBSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 326 326",
    style: {
      enableBackground: "new 0 0 326 326"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{fill:#EDEDED;}\n\t.st3{fill:#9CB182;}\n\t.st4{fill:#FCC331;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 326,
    height: 326
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M253.6,326H72.4C32.4,326,0,293.6,0,253.6V72.4C0,32.4,32.4,0,72.4,0h181.2c40,0,72.4,32.4,72.4,72.4v181.2 C326,293.6,293.6,326,253.6,326z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M272.9,167.5c-4.5,20.7-14.8,39.8-30.2,55.2c-21.1,21.1-49.1,32.7-78.9,32.7s-57.8-11.6-78.9-32.7 c-15.4-15.4-25.7-34.4-30.2-55.2H37.6c11.1,59.6,63.4,104.6,126.2,104.6s115-45.1,126.2-104.6L272.9,167.5L272.9,167.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M163.8,53.8c-49.7,0-90,40.3-90,90s40.3,90,90,90s90-40.3,90-90S213.5,53.8,163.8,53.8z M163.8,217 c-40.4,0-73.2-32.8-73.2-73.2s32.8-73.2,73.2-73.2s73.2,32.8,73.2,73.2S204.2,217,163.8,217L163.8,217z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAverecuraRgbBSmall);
export default __webpack_public_path__ + "static/media/averecura_RGB_B_Small.48457f2ccf0d7dfa79cecc4f7f4a1dcf.svg";
export { ForwardRef as ReactComponent };